<template>
  <div class="BoderWidth">
    <div class="HeaderContWidth">
      <div :span="24"
           class="HeaderWidth">
        <div class="header-left">
          <div class="ImgWidth">
            <div @click="drawer = true"
                 class="el-icon-s-unfold hidden-sm-and-up"></div>
            <router-link to='/'>
              <img src='../assets/images/logo.png' />
            </router-link>
          </div>
        </div>

        <div class="LoginFlex">
          <div class="NavCont hidden-xs-only">
            <router-link class="navText"
                         to='/'>
              <!-- 首页 -->
              <div>{{$t('index')}}</div>
            </router-link>
            <router-link class="navText"
                         to='/allGames'>
              <!-- 全部游戏 -->
              <div>{{$t('gamelist.allGame')}}</div>
            </router-link>
            <router-link class="navText"
                         to='/news'>
              <!-- 新闻 -->
              <div>{{$t('news')}}</div>
            </router-link>
          </div>
<!-- 		  <div @click="noLogin">
			    免登
		  </div> -->
          <div v-if="!AllUserInfo"
               class="LoginCont"
               @click="Loginshow = true"><img src='../assets/images/login.png' /></div>
          <div class="LoginCont"
               v-if="AllUserInfo">{{AllUserInfo.email ? AllUserInfo.email : AllUserInfo.telphone}}</div>

          <el-dropdown v-if="AllUserInfo"
                       @command="handleCommand"
                       trigger="click">
            <span class="el-dropdown-link">
              <img src='../assets/images/icon.jpg' />
            </span>
            <el-dropdown-menu slot="dropdown">
				<!-- 个人中心 -->
				<!-- <el-dropdown-item command="my">{{$t('个人中心')}}</el-dropdown-item> -->
              <!-- 登出 -->
              <el-dropdown-item command="signout">{{$t('signout')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <img @click="Loginshow = true"
               src='../assets/images/icon.jpg' /> -->
        </div>
      </div>
    </div>
    <el-drawer size='50%'
               title=""
               :visible.sync="drawer"
               :direction="direction"
               :with-header="false">
      <div class="IphoneNavCont">
        <div class="el-icon-back"
             @click="drawer = false"></div>
        <div class="IphoneNavText">
          <router-link class="phoneNavText"
                       to='/'>
            <!-- 首页 -->
            <div>{{$t('index')}}</div>
          </router-link>
          <router-link class="phoneNavText"
                       to='/allGames'>
            <!-- 全部游戏 -->
            <div>{{$t('gamelist.allGame')}}</div>
          </router-link>
          <router-link class="phoneNavText"
                       to='/news'>
            <!-- 新闻 -->
            <div>{{$t('news')}}</div>
          </router-link>
        </div>
      </div>
    </el-drawer>
    <login :Loginshow.sync="Loginshow"></login>
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/display.css'
import login from '@/components/login'
export default {
  name: 'Header',
  components: {
    login
  },
  data () {
    return {
      AllUserInfo: '',
      token: '',
      drawer: false,
      direction: 'ltr',
      Loginshow: false
    }
  },
  watch: {
    '$store.state.count' () {
      this.UserInfoLogin()
    }
  },
  created () {
    // console.log(this.$route.query.login == 'true')
    if (this.$route.query.login == 'true') {
      this.Loginshow = true
    }
    this.UserInfoLogin()
  },
  methods: {
    UserInfoLogin () {
      if (this.$store.state.count) {
        if (typeof (this.$store.state.count) == 'string') {
          this.AllUserInfo = JSON.parse(this.$store.state.count)
        } else {
          this.AllUserInfo = this.$store.state.count
        }
      } else {
        this.AllUserInfo = ''
      }

      this.token = this.$store.state.token
    },
    handleCommand (command) {
      if (command === 'signout') {//登出
        this.$store.commit('logout');
        this.visible = true
		this.$router.push('/')
      }
	  if (command === 'my') {//个人中心
	   this.$router.push('my')
	    // this.$router.push({ path: 'my' });
	  }
    },
	noLogin(){
		let res ={}
		res.data = {"resCode":"C502570000000","resMsg":"SUCCESS","sign":null,"userInfo":{"memberNo":"U288191029101452000001","loginId":"116253815675480609612","loginPwd":null,"payPwd":null,"fullName":null,"email":"sp.supraman@gmail.com","telphone":null,"status":1,"userType":"GG","createTime":1572315294000,"updateTime":1572315294000},"userToken":"eea1d437-0f69-4dba-84bc-865810176311"}
		this.$store.commit('login', res);
	}
  }
}
</script>

<style scoped>
.BoderWidth {
  width: 100%;
  background: #fff;
  /* border-bottom: 1px solid #ccc; */
}
.HeaderContWidth {
  width: 1040px;
  margin: 0 auto;
  height: 6.583rem;
}
.HeaderWidth {
  height: 6.583rem;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
.HeaderWidth .header-left {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
}
.ImgWidth {
  margin: 0 40px 0 0;
}
.ImgWidth img {
  width: 160px;
  vertical-align: middle;
}
.NavCont {
  margin: 0;
  height: 6.583rem;
  font-size: 16px;
  display: flex;
  justify-content: space-around;
}
.navText {
  margin: 0 36px 0 0;
  display: flex;
align-items: center;
}
.phoneNavText {
  margin: 0 0 1rem 0;
  display: block;
}
.NavCont > div {
  margin: 0 20px;
}
.LoginCont {
  height: 6.583rem;
  text-align: right;
  line-height: 6.583rem;
}
.LoginCont > img {
  margin: 0 0 0 15px;
  width: 2rem;
  vertical-align: middle;
}
.LoginFlex {
  display: flex;
  align-items: center;
}
.LoginFlex img {
  border-radius: 50%;
  margin: 0 0 0 15px;
  width: 3rem;
  height: 3rem;
  vertical-align: middle;
  cursor: pointer;
}
.el-icon-s-unfold {
  font-size: 3rem;
  float: left;
  height: 100%;
  line-height: 6.583rem;
  margin-right: 10px;
}

.IphoneNavText {
  color: white;
  font-size: 14px;
  text-align: center;
}
.IphoneNavText > div {
  line-height: 3rem;
}
.IphoneNavCont {
  width: 100%;
  height: 100%;
  background: #1989fa;
}
.el-icon-back {
  font-size: 30px;
  padding: 1rem;
  color: white;
}
@media (max-width: 1200px) {
  .HeaderContWidth {
    width: 88%;
  }
  .ImgWidth img {
    width: calc(90% - 1.083rem);
  }
}
@media (max-width: 992px) {
  .HeaderContWidth {
    width: 84%;
  }
  .ImgWidth img {
    width: calc(70% - 1.083rem);
  }
  .NavCont > div {
    margin: 0 10px;
  }
}
@media (max-width: 768px) {
  .HeaderContWidth {
    width: 82%;
  }
  .ImgWidth {
    margin: 0 20px 0 0;
  }
  .ImgWidth img {
    width: calc(70% - 1.083rem);
  }
}
@media (max-width: 576px) {
  .HeaderContWidth {
    width: 90%;
  }
  .HeaderContWidth {
    height: 5rem;
  }
  .ImgWidth {
    margin: 0 20px 0 0;
  }
  .ImgWidth img {
    width: calc(70% - 1.083rem);
  }
  .HeaderWidth,
  .LoginCont,
  .el-icon-s-unfold {
    height: 5rem;
    line-height: 5rem;
  }
  .el-icon-s-unfold {
    font-size: 25px;
  }
  .NavCont {
    height: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue